export default __webpack_public_path__ + "6bb57ff3a02932c433af1bdda40384c5.png";